import { ShieldSupportabilityEventType } from 'Workspace/TelemetryEvents/TelemetryEventTypes';

const code = 'WSUI_SHIELD_SUPPORTABILITY';

export interface LeaseCount {
	activeLeases: number;
	expiredLeases: number;
	expiringLeases: number;
	missingLeases: number;
}

export enum EventMode {
	AUTO = 'AUTO',
	MANUAL = 'MANUAL',
	HOURLY_REFRESH = 'HOURLY_REFRESH',
	ON_SUCCESS_CWA_SYNC = 'ON_SUCCESS_CWA_SYNC',
}

export interface ShieldSupportabilityPayload extends LeaseCount {
	eventMode: EventMode;
}

const preparePayload = (
	type: ShieldSupportabilityEventType,
	payload: ShieldSupportabilityPayload
) => ({
	type,
	code,
	...payload,
});
const createShieldSupportabilityCASReporter = () => {
	return {
		getLocalResyncAttemptEvent: (payload: ShieldSupportabilityPayload) =>
			preparePayload(ShieldSupportabilityEventType.LocalResyncAttempt, payload),
		getManualNetworkResyncEvent: (payload: ShieldSupportabilityPayload) =>
			preparePayload(ShieldSupportabilityEventType.ManualNetworkResync, payload),
		getCollectLogsEvent: (payload: ShieldSupportabilityPayload) =>
			preparePayload(ShieldSupportabilityEventType.CollectLogs, payload),
	};
};
export const shieldSupportabilityCASReporter = createShieldSupportabilityCASReporter();
